import { useRef } from "react";
import useToggleRow from "../../../../hooks/toggle-row.hook";
import ImageLoader from "../../../Common/ImageLoader";
import SelectArrowIcon from "../../../icons/select-arrow.icon";
import productUtils from "../../../../Utils/product.utils";


const TechSpendTab = ({ clientList, show }) => {
  return (
    <div className="techspend-tab-wrapper w-100">
      {clientList?.length > 0 ? (
        <>
          <div id="techspend-tab-parent" className="techspend-tab w-100 hide-scrollbar">
            {clientList?.map((item, index) => (
              <CompanyItem key={index} item={item} />
            ))}
          </div>
        </>
      ) : (
        <div className="techspend-tab-content-item d-flex align-items-center gap-16 p-4">
          <span className="techspend-tab-content-item-label">No products</span>
        </div>
      )}
    </div>
  )
}

export default TechSpendTab;

const CompanyItem = ({ item }) => {
  const rowRef = useRef(null);
  const { panelRef, toggleRow, isOpenFixed } = useToggleRow({ rowRef, parentId: 'techspend-tab-parent' });

  return (
    <div className="point techspend-tab-item-wrapper" ref={rowRef}>
      <div className="techspend-tab-item cursor-pointer" onClick={() => toggleRow()}>
        <div className="d-flex align-items-center gap-8">
          <ImageLoader
            width={24} 
            height={24} 
            src={item.Avatar} 
            alt=""
            className="rounded-full"
            noImageComponent={(
              <img width={24} height={24} src={'/images/user-logo.svg'} alt="" />
            )}
          />
          <span className="techspend-tab-item-label f-black">{item.Name}</span>
        </div>
        <div>
          <SelectArrowIcon className={isOpenFixed ? 'rotate180' : ''} />
        </div>
      </div>
      <div className="panel" ref={panelRef}>
        <div className="techspend-tab-item-panel">
          {item.TechSpendProducts?.map((product, index) => (
            <div key={product.Id} className="techspend-tab-content-item d-flex align-items-center gap-16">
              <img src={productUtils.getProductStateIconPath(product.Status)} alt="" />
              <span className="techspend-tab-content-item-label">
                {product.productName}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
